import type * as React from 'react';
import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { Badge, badgeClasses, Button } from '@mui/material';

/**
 * Use either onClick or path to navigate to the filter
 */
type ButtonLinkProps = {
    /**
     * Action when we click the filter.
     */
    onClick?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
    /**
     * URL path to the filter
     */
    path?: string;
    /**
     * Number of filter items
     */
    n: number;
};
export default function ButtonLink({
    path = '',
    onClick,
    n,
    ...props
}: ButtonLinkProps) {
    const navigate = useNavigate();

    return (
        <Button
            {...props}
            variant="outlined"
            sx={{ minWidth: 135 }}
            onClick={(event) => {
                if (path !== '') {
                    navigate(path);
                }
                if (onClick) {
                    onClick(event);
                }
            }}
        >
            <FormattedMessage
                defaultMessage="Filter {count}"
                values={{
                    count:
                        n > 0 ? (
                            <Badge
                                color="primary"
                                badgeContent={n}
                                sx={{
                                    [`& .${badgeClasses.badge}`]: {
                                        position: 'relative',
                                        transform: 'none',
                                    },
                                }}
                            >
                                &nbsp;
                            </Badge>
                        ) : null,
                }}
                description="Filter Button"
            />
        </Button>
    );
}
